import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
    name:'app',
    initialState:{
        commonInfo:{},
        userInfo: {},
        helpLineWhatsAppNumber:'',
        commonHelpline:{},
        withdrawalStatus:{},
        newsData:{},
    },
    reducers:{
        setCommonInfo:(state,action) => {
            state.commonInfo = {...state.commonInfo, ...action.payload}
        },
        setUserInfo:(state, action) => {
            state.userInfo = {...state.userInfo, ...action.payload};
        },
        setHelpLineWhatsAppNumber:(state, action) => {
            state.helpLineWhatsAppNumber = action.payload;
        },
        setCommonHelpline:(state, action) => {
            state.commonHelpline = {...state.commonHelpline, ...action.payload};
        },
        setWithdrawalStatus:(state, action) => {
            state.withdrawalStatus = {...state.withdrawalStatus, ...action.payload};
        },
        setNewsData:(state, action) => {
            state.newsData = {...state.newsData, ...action.payload};
        }
    }
});

export const { setCommonInfo, setUserInfo, setHelpLineWhatsAppNumber, setCommonHelpline, setWithdrawalStatus, setNewsData } = appSlice.actions;
export default appSlice.reducer;